export enum Theme {
  IW = 'immowelt',
  IN = 'immonet'
}
